import { AppUrls } from './app-urls';

export class ClientUrlBuilder {
  public static build(url: string): string {
    return `/${AppUrls.Client}/${url}`;
  }

  public static buildDate(url: string, date?: Date): string {
    return `/${AppUrls.Client}/${url}?date=${date?.toISOString()}`;
  }
}

export class ClientUrls {
  public static Planning = `planning`;
  public static Today = `today`;
  public static Accounts = `accounts`;
  public static AccountDetail = `accounts/:id`;
  public static Tasks = `tasks`;
  public static Activities = `activities`;
  public static Profile = `profile`;
  public static Impersonation = `impersonation`;
  public static CreateLoop = `planning/create-loop`;
  public static Maintenance = `maintenance`;

  public static accountDetail(id: string): string {
    return `accounts/${id}`;
  }
}

export class ProfileUrls {
  public static Accounts = `accounts`;
  public static AccountDetail = `accounts/:id`;
  public static Segmentation = `segmentation`;
  public static Users = `users`;
  public static Clusters = `clusters`;
  public static Campaigns = `campaigns`;
  public static CampaignDetail = `campaigns/:clusterId/:id`;
  public static SalesOrganizations = `sales-organizations`;
  public static SalesOrganizationDetail = `sales-organizations/:id`;
  public static EditProfile = `edit`;
  public static Settings = `settings`;
  public static Impersonation = `impersonation`;
  public static InviteAdmin = `invite-admin`;

  public static accountDetail(id: string): string {
    return `profile/accounts/${id}`;
  }
}
